import { converters as tableConverters } from 'store/table';
import { IShopUser } from 'types/income';
import { loaders } from './shop-users.loaders';
import { ShopUser } from './shop-users.types';

const convertShopUser = (shopUser: IShopUser): ShopUser => {
  return {
    id: shopUser.id,
    employee: {
      id: shopUser.employeeId,
      fullName: shopUser.fullName,
      email: shopUser.email ?? '',
      phone: shopUser.phoneNumber ?? '',
    },
    company: {
      id: shopUser.companyId,
      name: shopUser.companyName,
      code: shopUser.companyCode,
    },
    parentCompany: {
      id: shopUser.parentCompanyId,
      name: shopUser.parentCompanyName,
    },
    paymentCount: shopUser.paymentCount,
    lastActive: shopUser.lastActive,
    createdAt: shopUser.createdAt,
  };
};

const convertShopUsers = (shopUsers: IShopUser[]): ShopUser[] => {
  return shopUsers.map(convertShopUser);
};

export const converters = {
  getShopUsers: ({
    data,
  }: Awaited<ReturnType<typeof loaders.getShopUsers>>) => {
    const { total, page, pageSize, pages } = tableConverters.getTableData(data);

    return {
      items: convertShopUsers(data.data),
      total,
      page,
      pageSize,
      pages,
    };
  },
  getShopUser: ({ data }: Awaited<ReturnType<typeof loaders.getShopUser>>) => {
    return convertShopUser(data);
  },
};
